// =============================================================================
// difficulty.ts — Níveis de dificuldade da eleição: multiplicam a vida e o
// dano dos oponentes. O chefe da chapa escolhe no lobby; o servidor aplica.
// =============================================================================

export interface DifficultyDef {
  id: string;
  nome: string;
  emoji: string;
  sub: string;       // subtítulo curto do card de dificuldade no lobby
  desc: string;
  hpMult: number;    // multiplica o HP de inimigos e bosses
  dmgMult: number;   // multiplica todo dano sofrido pelos jogadores
  countMult: number; // multiplica a QUANTIDADE de inimigos (taxa + teto na tela)
}

export const DIFFICULTIES = {
  normal: {
    id: 'normal', nome: 'Normal', emoji: '📊',
    sub: 'Equilibrada',
    desc: 'Um segundo turno padrão. O Brasil de sempre.',
    hpMult: 1, dmgMult: 1, countMult: 1,
  },
  caotica: {
    id: 'caotica', nome: 'Caótica', emoji: '⚡',
    sub: 'Eventos imprevisíveis',
    desc: 'Véspera de eleição presidencial. A militância tomou café — e é MUITO mais gente.',
    hpMult: 1.5, dmgMult: 1.4, countMult: 1.5,
  },
  apuracao_final: {
    id: 'apuracao_final', nome: 'Apuração Final', emoji: '⚠️',
    sub: 'Para veteranos',
    desc: '8 de Janeiro em loop, com o TRIPLO da horda. Só pra quem já perdeu a esperança.',
    hpMult: 2.2, dmgMult: 1.9, countMult: 3,
  },
} satisfies Record<string, DifficultyDef>;

export type DifficultyId = keyof typeof DIFFICULTIES;

export const DEFAULT_DIFFICULTY: DifficultyId = 'normal';

// Lookup por id vindo da rede (string qualquer)
export const DIFFICULTY_TABLE: Record<string, DifficultyDef | undefined> = DIFFICULTIES;

export function isDifficultyId(v: unknown): v is DifficultyId {
  return typeof v === 'string' && v in DIFFICULTIES;
}
